import { selectFromBillingSubscription, smsAddonSubscribedDtoModelPrimitives, smsAddonFailedDtoModelPrimitives } from '../models';
import { SubscriptionHandler } from '../utils/createSubscription';
import BillingPlanQuery from '../queries/billing/BillingPlanQuery';
import billingPlanUpdatedHandler from './handlers/billing/billingPlanUpdatedHandler';
import smsAddonSubscribedHandler from './handlers/billing/smsAddonSubscribedHandler';
import smsAddonFailedHandler from './handlers/billing/smsAddonFailedHandler';

const selector = selectFromBillingSubscription()
  .billingPlanUpdatedDto(b => b.billingPlan(BillingPlanQuery))
  .billingCycleUpdatedDto(b => b.billingPlan(BillingPlanQuery))
  .billingPlanCancellationRequestedDto(b => b.billingPlan(BillingPlanQuery))
  .billingPlanCancellationRevokedDto(b => b.billingPlan(BillingPlanQuery))
  .smsAddonSubscribedDto(smsAddonSubscribedDtoModelPrimitives)
  .smsAddonFailedDto(smsAddonFailedDtoModelPrimitives)
  .toString();

export default (): SubscriptionHandler => ({
  name: 'BillingSubscription',
  selector,
  events: new Map(Object.entries({
    BillingPlanUpdatedDto: [billingPlanUpdatedHandler],
    BillingCycleUpdatedDto: [() => {}],
    SmsAddonSubscribedDto: [smsAddonSubscribedHandler],
    SmsAddonFailedDto: [smsAddonFailedHandler],
  })),
  onError(error: Error) {
    console.error('BillingSubscription Error, check if websocket client initialized', JSON.stringify(error));

  },
});
